export default __webpack_public_path__ + "static/media/JUNIOR.6c1e6f9d.png";